import React from 'react';
import './Petpreform.css';
import preformVideo from '../../../video/PreformVideo.mp4'; 
import Reqprodcte from "../../../components/Reqprodcte";


const Petpreform = () => {
  return (
    <div className="petpreform-banner">
      <video autoPlay loop muted className="background-video">
        <source src={preformVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="overlay-content">
        <h1>PET Preform</h1>
        <h2>Injection Molding Machine</h2>
        <h3>Powerjet PET & KPET Series</h3>
          <div className='stnd'>
                    <Reqprodcte />
                </div>
      </div>
    </div>
  );
};

export default Petpreform;
